module["exports"] = ["s Väg", "s Gata"];